import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import toast from 'react-hot-toast';
import { SettingsActions } from 'store/actions';
import { PortalSpinner } from 'components/PortalSpinner';
import Form from 'components/Settings/Preferences/Form';

const enhancer = connect(null, { ...SettingsActions });

const Settings = ({ showSettings }) => {
  const [settings, setSettings] = useState(null);
  let preferences = settings?.attributes?.preferences?.data?.attributes || {};

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const { data } = await showSettings();
      setSettings(data);
    } catch (error: any) {
      toast.error(error.errors || 'Failed to load settings. Please try again later.');
    }
  };

  return (
    <div className="relative -m-5 flex-1 lg:-m-6">
      <div className="absolute inset-0 flex flex-col overflow-hidden">
        <div className="shrink-0 px-5 pt-5 lg:px-6 lg:pt-6">
          <h1 className="text-2xl font-bold text-secondary-900">Settings</h1>
          <p className="mt-0.5 text-sm text-secondary-500">Manage how and when we reach you.</p>
        </div>

        {settings ? <Form preferences={preferences} /> : <PortalSpinner />}
      </div>
    </div>
  );
};

export default enhancer(Settings);
